import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-semi-select",
  "use": "icon-semi-select-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-semi-select\">\n<path d=\"M11.5 0.5H2.5C1.39543 0.5 0.5 1.39543 0.5 2.5V11.5C0.5 12.6046 1.39543 13.5 2.5 13.5H11.5C12.6046 13.5 13.5 12.6046 13.5 11.5V2.5C13.5 1.39543 12.6046 0.5 11.5 0.5Z\" fill=\"#21a1f2\" fill-opacity=\"0.07\" stroke=\"#21a1f2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol